<template>
    <div class="col-md-6 drop-lg">
        <!-- Client has no credit card -->
        <div v-if="! userHasCreditCard">
            <template v-if="userHasPermission">
                <a href="#" v-b-modal.modal-add-credit-card class="payment-group sau-bx-payment payment-desat-img d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400">
                    <span class="mt-2"></span>
                    <img src="/img/cards-accepted.gif" alt="Accepted Credit Cards" class="img-fluid pb-2">
                    <p class="sau-font sm">Add a Credit Card to your account</p>
                </a>
            </template>
            <template v-else>
                <a  href="#"
                    @click.prevent
                    class="no-card-hover payment-group sau-bx-payment payment-desat-img d-flex-column h-100 justify-content-center pb-12 border-grey-400 cursor-not-allowed"
                >
                    <span class="mt-2"></span>
                    <img src="/img/cards-accepted.gif" alt="Accepted Credit Cards" class="img-fluid pb-2">
                    <p class="sau-font sm">Contact your account holder to add a credit card.</p>
                </a>
            </template>
        </div>

        <!-- Client has credit card and account view -->
        <div v-if="userHasCreditCard && canUpdatePaymentOptions">
            <div class="payment-group active sau-bx-payment d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400 cursor-default">
                <div>
                    <img :src="creditCardImage" alt="Your Credit Card" class="img-fluid pb-2 mt-2">
                    <div class="text-center">
                        <p class="sau-font"><span v-html="cardNumber" class="mr-4"></span>{{ cardExpiry }}</p>
                    </div>
                </div>
                <div class="payment-method-options">
                    <div class="sau-menu">
                        <button class="dropbtn text-green">
                            Options
                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                        </button>
                        <div class="sau-menu-content dd py-4 px-6">
                            <!-- <button class="block" v-b-modal.modal-add-credit-card>Update Card</button> -->
                            <button class="block" @click="destroyCreditCard()">Remove Card</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Client has a credit card and payment view -->
        <div v-if="userHasCreditCard && ! canUpdatePaymentOptions" @click.prevent="setPaymentMethod('creditcard')">
            <div class="payment-group sau-select lg center payment d-flex-column active h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400" :class="{selected: this.paymentMethodSelected === 'creditcard'}">
                <label for="creditcard">
                    <input id="creditcard" type="radio" name="payment-type" v-model="this.paymentMethodSelected" value="creditcard">
                    <span class="mt-2"></span>
                    <img :src="creditCardImage" alt="Your Credit Card" class="img-fluid pb-2 payment-max">
                    <div class="text-center">
                        <p class="sau-font"><span class="not-a-radio-button mr-4" v-html="cardNumber"></span>{{ cardExpiry }}</p>
                    </div>
                </label>
            </div>
        </div>
        <!-- Modal Add credit Card -->
        <sau-add-credit-card :update="update" :spk="spk"></sau-add-credit-card>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import AddCreditCard from "./_PaymentCCAdd";

    export default {
        props: ['cardType', 'cardLastFour', 'cardExpiry', 'update', 'spk'],

        components: {
            "sau-add-credit-card": AddCreditCard,
        },

        methods: {
            destroyCreditCard() {
                this.$swal({
                    title: 'Are you sure?',
                    text: "This will remove your credit card and will stop any future payments",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, remove it',
                    confirmButtonClass: 'btn btn-danger',
                    cancelButtonText: 'No, cancel',
                    cancelButtonClass: 'btn btn-link',
                    buttonsStyling: false,
                    reverseButtons: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                this.deleteRequest('/api/billing/creditcard').then(response => {
                                    if (this.paymentMethodSelected == 'creditcard') {
                                        this.$store.commit('paymentMethodSelected', '');
                                    }
                                    this.update();
                                    resolve();
                                }).catch(error => {
                                    this.$swal({
                                        type: 'error',
                                        title: 'There seems to be a problem',
                                        html: 'There has been a problem removing your Credit Card. Please try again.',
                                        buttonsStyling: false,
                                        confirmButtonText: 'Close',
                                        confirmButtonClass: 'btn btn-danger'
                                    });
                                });
                            }, 2000)
                        });
                    },
                    allowOutsideClick: () => !this.$swal.isLoading(),

                })
            },
        },

        computed: {
            userHasCreditCard() {
                return this.cardType && this.cardLastFour;
            },

            cardNumber() {
                return `&bull;&bull;&bull;&bull; ${this.cardLastFour}`;
            },

            userHasPermission() {
                return this.userDetails.whmcs_contact_id
                    ? this.userDetails.permissions.split(",").indexOf('profile') > -1
                    : true;
            },

            creditCardImage() {
                switch (this.cardType.toLowerCase()) {
                    case 'visa':
                        return '/img/cc-vs-bb.gif';
                    case 'mastercard':
                        return '/img/cc-mc-bb.gif';
                    case 'american express':
                    case 'amex':
                        return '/img/cc-ax-bb.gif';
                    default:
                        return '/img/cc-blank-bb.gif';
                }
            },

            ...mapGetters(['canUpdatePaymentOptions']),

        },
    }

</script>
<style lang="scss" scoped>
    .sau-select span.not-a-radio-button {
        background-image: none !important;
        width: auto !important;
        height: auto !important;
    }
</style>
